import React, { useEffect, useState } from "react";
import "./AnnouncementPostType.scss";
import { useSearchParams } from "react-router-dom";
import { CommonEnums } from "../../../../enums/common.enums";
import Modal from "@mui/material/Modal";
import { TemplatesApi } from "../../../../utils/api/Templates";
import { PropertyApi } from "../../../../utils/api/Property";
import toast from "react-hot-toast";

interface AnnouncementPostTypeProps {
  selectedType: string | null;
  onSelectType: (type: string | null) => void;
  onContinue: (title: string) => void;
}

const AnnouncementPostType = ({
  selectedType,
  onSelectType,
  onContinue,
}: AnnouncementPostTypeProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isProcessing, setIsProcessing] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const paramType = searchParams.get("post_type");
    if (paramType && paramType !== selectedType) {
      onSelectType(paramType);
    }
  }, [searchParams, selectedType, onSelectType]);

  const handleSelect = async (type: string) => {
    setModalOpen(true);
    setIsProcessing(true);

    try {
      const payload = { post_type: type };

      let announcementPostId = searchParams.get("announcement_post_id");
      let res;

      if (announcementPostId) {
        res = await PropertyApi.updateAnnouncementPost(
          payload,
          announcementPostId
        );
      } else {
        res = await PropertyApi.createAnnouncementPost(payload);
        announcementPostId = res?.data?.data?._id;

        if (!announcementPostId) {
          toast.error("Failed to create announcement post.");
          return;
        }
      }

      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        next.set("announcement_post_id", announcementPostId!);
        next.set("post_type", type);
        next.set("step", CommonEnums.announcementPostTabs.announcement_type.key);
        return next;
      });

      onSelectType(type);
    } catch (error) {
      console.error("Failed to create/update announcement post", error);
      toast.error("Something went wrong while saving the announcement post.");
    } finally {
      setIsProcessing(false);
      setModalOpen(false);
    }
  };

  const handleCancel = () => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete("post_type");
    setSearchParams(nextParams);
    onSelectType(null);
  };

  const postTypeData = [
    {
      id: "1",
      icon: "/images/workspace/image.svg",
      title: "Image Post",
      type: CommonEnums.postType.image_post.key,
    },
    {
      id: "2",
      icon: "/images/workspace/image.svg",
      title: "Story Post",
      type: CommonEnums.postType.story_post.key,
    },
    {
      id: "3",
      icon: "/images/workspace/video.svg",
      title: "Video Post",
      type: CommonEnums.postType.video_post.key,
    },
    {
      id: "4",
      icon: "/images/workspace/video.svg",
      title: "Reel Post",
      type: CommonEnums.postType.reel_post.key,
    },
  ];

  return (
    <div className="property-post-type-container">
      <h3 className="step-title">Select Post Type to Continue</h3>

      <div className="template-type-list-container">
        {postTypeData.map((data) => (
          <div
            key={data.type}
            className={`template-type-box ${
              selectedType === data.type ? "selected" : ""
            } ${
              data.type === CommonEnums.postType.story_post.key
                ? "story-post"
                : data.type === CommonEnums.postType.reel_post.key
                ? "reel-post"
                : data.type === CommonEnums.postType.image_post.key
                ? "image-post"
                : data.type === CommonEnums.postType.video_post.key
                ? "video-post"
                : ""
            }`}
            onClick={() => handleSelect(data.type)}
          >
            <div className="template-image-wrapper">
              <img src={data.icon} alt={data.title} />
            </div>
            <div className="template-title-below">
              <p>{data.title}</p>
            </div>
          </div>
        ))}
      </div>

      {/* {selectedType && (
        <div className="property-post-actions">
          <button className="cancel-button" onClick={handleCancel}>
            Cancel
          </button>
          <button
            className="continue-button active"
            onClick={() => {
              const selectedTypeTitle =
                postTypeData.find((d) => d.type === selectedType)?.title || "";
              onContinue(selectedTypeTitle);
            }}
          >
            Continue
          </button>
        </div>
      )} */}

      <Modal
        open={modalOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            setIsProcessing(false);
          }
        }}
        aria-labelledby="processing-modal"
        className="add-property-modal styled-modal"
        disableEscapeKeyDown
      >
        <div className="modal-center-wrapper">
          <div className="loading-content-wrapper">
            {isProcessing && (
              <div className="loading-container">
                <div className="spinner" />
                <p className="loading-text">
                  Processing your request
                  <span className="desktop-break">
                    <br />
                  </span>
                  Please wait...
                </p>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AnnouncementPostType;
